import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Form, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
import { CertificadosService } from 'src/app/services/certificados.service';
import { RutValidator } from 'ng9-rut';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';

declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-seguimiento-certificados',
  templateUrl: './seguimiento-certificados.component.html',
  styleUrls: ['./seguimiento-certificados.component.css'],
  providers: [CertificadosService, ClaveUnicaService]
})
export class SeguimientoCertificadosComponent implements OnInit {

  public certificado_info
  public arreglo
  buscando = false
  public numSol = new FormControl('', [Validators.required]);
  public search;
  public fecha_ingreso = new FormControl('', [Validators.required]);
  public link
  public fechaIngeso


  identity
  token

  constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private store: Store<AppState>,
    private _cert: CertificadosService, private spinner: NgxSpinnerService,
    private _cd: ChangeDetectorRef, private _rutvalidator: RutValidator, private _formBuilder: FormBuilder, private _userService: UserService, private _router: Router, private claveUnicaService: ClaveUnicaService) {
    this.search = this._formBuilder.group({
      rut: ['', [Validators.required, this._rutvalidator]],
      numSol: ['', [Validators.required]],

    });

  }

  ngOnInit() {
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  get_certificado() {
    this.spinner.show()
    this._cert.get_certificado(this.search.controls.rut.value, this.search.controls.numSol.value).subscribe(response => {
      console.log(response)
      if (response.certificado.length > 0) {

        this.spinner.hide()
        this.certificado_info = response.certificado[0].fieldData
        let firma = this.certificado_info._Firma_COD
        if (response.tipo == "certificado") {
          this.fechaIngeso = moment(new Date(this.certificado_info._Cer_Fecha_Ingreso)).format("DD-MM-YYYY")
        } else {
          this.fechaIngeso = moment(new Date(this.certificado_info._Cat_Fecha_Ingreso)).format("DD-MM-YYYY")
        }

        if (response.tipo == "certificado" && this.certificado_info._Firma_COD) {
          this.link = "Https://bucket-dom-mpa.s3.amazonaws.com/" + firma + ".pdf"
        } else if (response.tipo == "catastro" && this.certificado_info._Firma_COD) {
          this.link = "Https://bucket-dom-mpa.s3.amazonaws.com/" + firma + ".pdf"
        }

        this.buscando = true

      } else {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron registros de certificados con ese numero de solicitud",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
    })

  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  volver() {
    this.buscando = false
    this.search.controls.rut.setValue("")
    this.search.controls.numSol.setValue("")

  }

}
